<template>
  <v-container class="pa-0" fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t('Viešų JA sąrašas') }}</h1>

    <el-autocomplete
      :items="jarForms"
      itemvalue="code"
      itemtext="text"
      label="Teisinė forma"
      tooltip="Ireg. Pagrindinis. Dokumentai. Siunčiamų dokumentų žurnalas. Siuntimo būdas"
      multiple
      v-model="selectedForms"
    />
    <!-- add button  -->
    <el-button
      class="mb-5"
      color="primary"
      icon="pridėti"
      title="Pridėti JA formas"
      :loading="loading"
      @click.native.stop="addItems()"
    />
    <!-- search -->
    <public-ja-search
      :loading="loading"
      @search="searchList"
    />
    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :item-class="rowClass"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal')
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="setItemActions(item)"
            @deleteItem="deleteItem(item)"
          />
        </div>
      </template>
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }} {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
    <modal-delete
      title="Šalinti įrašą"
      text="Ar tikrai norite pašalinti įrašą?"
      v-model="showDelete"
      :loading="loading"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import userRole from '@/mixins/userRole'
import ModalDelete from '@/components/modals/ModalDelete'
import tableParameters from '@/mixins/tableParameters'
import PublicJaSearch from './PublicJaSearch'

export default {
  name: 'PublicJaFormsIndex',
  components: {
    ModalDelete,
    PublicJaSearch
  },
  mixins: [userRole, tableParameters],
  data() {
    return {
      pageloading: true,
      loading: false,
      paginationloading: false,
      search: null,
      showDelete: false,
      modalDeleteItem: null,
      listData: [],

      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 10,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
      jarForms: {lt: [], en: []},
      searchData: {},
      selectedForms: [],
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('Kodas'),
          align: 'start',
          value: 'code',
        },
          {
          text: this.$t('Pavadinimas LT'),
          align: 'start',
          value: 'title_lt',
        },
        {
          text: this.$t('Pavadinimas EN'),
          align: 'start',
          value: 'title_en',
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  beforeDestroy() {

  },
  created() {
    this.getClassifiers()
  },
  methods: {
    searchList(searchData) {
      this.searchData = searchData
      this.loading = true
      this.getData(searchData.btn)
    },
    setItemActions(item) {
      item.canDelete = true
      return item
    },
    getClassifiers() {
      this.pageloading = true
      let requiredClassifiers = { classifiers: ['jar-form'] }
      this.$axios
        .post(`classifiers`, requiredClassifiers)
        .then((res) => {
          this.jarForms['lt'] = res.data.classifiers['jar-form']['lt'].filter((item) => {
            return !item.is_public
          })
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }

      this.setSortParams()

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`public-ja-list/list`, data)
        .then((res) => {
          this.listData = res.data.jarForms
          this.pagination = { ...this.pagination, ...res.data.pagination }

        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
          pageSize: pagination.itemsPerPage,
          page: pagination.page,
          route: this.$route.name,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    deleteItem(item) {
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    addItems(item) {
      this.pageloading = true
      this.$axios.post(`public-ja-list/add-to-list`, {ids: this.selectedForms})
      .then((res) => {
        this.$root.$emit('DATA_OK_CODE', '000110')
        this.getClassifiers()
        this.getData()
      })
      .catch((err) => {
        this.$root.$emit('DATA_ERROR', err)
      })
      .finally(() => {
        this.pageloading = false
        this.selectedForms = []
      })
    },
    confirmDelete(item) {
      this.loading = true

      this.$axios
        .post(`public-ja-list/${item.code}/remove-from-list`)
        .then((res) => {
          this.$root.$emit('DATA_OK_CODE', '000111')
          this.getClassifiers()
          this.getData()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.showDelete = false
        })
    },

    rowClass(item) {
      if (item.status === 'warning') {
        return `status-warning`
      }
      if (item.status === 'outdate') {
        return `status-outdate`
      }
      if (item.status === 'repost') {
        return `status-repost`
      }
      return ''
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>
